/**
 * English Features Translations
 * 特性翻译模块 - 英语
 * 
 * SEO 关键词覆盖：
 * - far infrared heater / radiant heater
 * - energy efficient / energy saving
 * - nano coating / emissivity
 */

import type { FeaturesTranslations } from '../../types';

export const enFeatures: FeaturesTranslations = {
  tech: {
    title: 'Innovative Far Infrared Heating Element',
    description: 'JH infrared heaters emit far-infrared rays that warm people and objects directly — just like natural sunshine. This radiant heating delivers fast, even, silent warmth with no noise, no wind, no light, and no dust, while consuming up to 80% less energy than conventional convection heaters.',
    aluminum: 'Finned-type special aluminum alloy for rapid heat conduction',
    nano: 'Patented NANO-ceramic coating for maximum far-infrared emission',
    insulation: '86% far-infrared ray emission efficiency — industry leading',
    lifespan: 'Patented reflective heat storage technology (+20% energy saving)',
  },
};
